<div *ngIf='tableReady' class='RemoveContactsFromDomainDialog'>
  <div *ngIf='totalItems > 0'>
    <p>Do you want to remove the other <b>{{ totalItems }}</b> contacts in the <b>"{{ domain }}"</b> domain from all of
      your
      campaigns?</p>
    <p>Check the item to flag contact as inactive</p>
  </div>
  <app-table (rowSelected)='onRowSelected($event)' [columns]='tableColumns' [dataSourceParams]='dataSourceParams'
             [dataSource]='dataSource' [selectable]='true'></app-table>
</div>